import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Marquee } from "@/components/Marquee";
import Hero from "@/sections/Hero";
import Problem from "@/sections/Problem";
import Framework from "@/sections/Framework";
import Intelligence from "@/sections/Intelligence";
import Lifecycle from "@/sections/Lifecycle";
import DoNothing from "@/sections/DoNothing";
import Alerts from "@/sections/Alerts";
import Analytics from "@/sections/Analytics";
import Identity from "@/sections/Identity";
import Community from "@/sections/Community";
import HowItWorks from "@/sections/HowItWorks";
import Results from "@/sections/Results";
import Pricing from "@/sections/Pricing";
import FAQ from "@/sections/FAQ";
import FinalCTA from "@/sections/FinalCTA";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Problem />
        <Framework />
        <Intelligence />
        <Lifecycle />
        <DoNothing />
        <Alerts />
        <Analytics />
        <Identity />
        <Community />
        <HowItWorks />
        <Results />
        <Pricing />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}
